import PageShell from "./PageShell";
import Contact from "../components/landing/Contact";

const ContactPage = () => (
  <PageShell title="Get Started">
    <Contact />
  </PageShell>
);

export default ContactPage;
